<template >
    <div>
      <div v-if="loader" id="loader"></div>

     <div class="page-header d-flex w-100 driver_header_mobile">
      <div class="title-col d-flex w-50">
        <span class="title-icon">
          <b-icon-folder-fill></b-icon-folder-fill>
        </span>
        <span class="title-text">Report Master</span>
      </div>
     </div>
     <div class="page-body sm-grid loading">
    
      <Grid ref="grid" v-bind:style="{ height: gridHeight + 'px' }" :data-items="items" :sortable="true"
       :sort="sort" :columns="columns" :pageable="pageable" :skip="skip" :take="take" :total="total" 
       :page-size="pageSize" @pagechange="pageChangeHandler" @edit="edit" @remove="remove"
         @expandchange="expandChange"
         :expand-field="'expanded'"
        :detail="detailReport"
      >
      
      <grid-toolbar>
        <div class="d-flex">
          <div class="mr-auto mobile_hide_show">
            <h5 class="mt-1">REPORT DETAILS</h5>
          </div>

          <div class="text-right">
            <button class="btn btn-itt" @click="goToAddPage">
              <span class="nt-plus"></span>
              <span class="btn-icon-text"> ADD REPORTS </span>
            </button>
          </div>
          
          <input type="text" v-model="searchText" class="form-control ml-2 search_mobile" placeholder="Search" />
        
        </div>
      </grid-toolbar>
    </Grid>
  </div>
  
    </div>
  </template>
  <script>
      import CommandCell from "@/components/CommandCellTemplate/CommandCellTemplate.vue";
      import { createNamespacedHelpers } from "vuex";
      import Vue from "vue";
      const { mapState } = createNamespacedHelpers("reportMaster");
      import { orderBy } from "@progress/kendo-data-query";
      import DetailReport from "./DetailReport.vue"
      import { notify, notifyApiError } from "@/utils/notification-helper";
      import { MESSAGES } from "@/utils/constants";



  export default {
    data: function() {
    return {
      reportDeleteData: {},
      title: null,
      gridHeight: window.innerHeight - 120,
      gridData: [],
      searchText:"",
      skip: 0,
      take: 25,
      pageSize: 25,
      pageable: {
        previousNext: true,
        pageSizes: [5, 10, 25, 100, 500],
        pageSize: 10,
      },
      add: true,
      sort: [{ field: "name", dir: "asc" }],
      filteredColumns: [],
      detailReport: DetailReport,

      columns: [
        { hidden: false, field: "name", title: "Name",  width: '200px',  checked: true, defaultSelected: true, },
        { hidden: false, field: "description", title: "Description",  width: '200px',  checked: true, defaultSelected: true, },
        { hidden: false, field: "isClientSpecific", title: "IsClient Specific",  width: '150px', checked: true, defaultSelected: true, },
        { hidden: false, field: "isVisible", title: "IsVisible",  width: '150px', checked: true, defaultSelected: true, },
        { hidden: false, field: "reportTitle", title: "Report Title", width: '150px', checked: true, defaultSelected: true, },
        { hidden: false, field: "reportGroupID", title: "Report GroupID",cell: this.groupName,  width: '150px', checked: true, defaultSelected: true, },        
        { hidden: false, field: "parentReportID", title: "Parent Report ID",cell: this.reportgroupName,  width: '150px', checked: true, defaultSelected: true, },
       // { hidden: false, field: "RedirectUrl", title: "Redirect Url", cell: this.sensors,  width: '150px', checked: true, defaultSelected: false, },
        { hidden: false, cell: CommandCell, width: '150px', locked: true, title: "Actions",  ignoreCheckbox: true, },
      ],
      dataItems: [],
    };
  },
  methods:{
    pageChangeHandler: function(event) {
      this.skip = event.page.skip;
      this.take = event.page.take;
    },
    expandChange(event) {
      const isExpanded =
        event.dataItem.expanded === undefined
          ? event.dataItem.aggregates
          : event.dataItem.expanded;
      Vue.set(event.dataItem, "expanded", !isExpanded);
    },
    goToAddPage: function() {
      this.$router.push({ name: "reportMasterAdd", params: { add: true } });
    },

    getDataOnload(){
      this.$store.dispatch("reportMaster/getParentReportById", this.ParentGroupIdData)
      this.$store.dispatch("reportMaster/getInitialData", this.initialData)
     this.$store.dispatch("reportMaster/getAllReports", this.reportMasterList);
    },

    groupName: function(h, tdElement, props) {
      const field = props.field;
      var value = props.dataItem[field];
      if (!value) {
        return h("td", {}, "");
      }
      if(this.initialData.reportGroups) {
        const grp = this.initialData.reportGroups.find((t) => t.id === value);
        return h("td", {}, grp ? grp.name : '');
      }
    },
    reportgroupName: function(h, tdElement, props) {
      const field = props.field;
      var value = props.dataItem[field];
      if (!value) {
        return h("td", {}, "");
      }
      if(this.ParentGroupIdData) {
        const grp = this.ParentGroupIdData.find((t) => t.id === value);
        return h("td", {}, grp ? grp.name : '');
      }
    },
    edit: function(item) {
      return this.$store.dispatch("reportMaster/editReportMaster", item.dataItem.id); 
    },
    remove(item){
         return this.$store
        .dispatch("reportMaster/deleteReportMaster", item)
        .then(() => {
          notify(MESSAGES.DELETE_SUCCESS);
        })
        .catch(notifyApiError);
      }
    
  },
  computed: {
    total() {
      return this.reportMasterList ? this.reportMasterList.length : 0;
    },
    ...mapState(["loader", "reportMasterList", "initialData","ParentGroupIdData"]),
    reportListVal() {
      return this.reportMasterList.filter(
        (data) =>
          JSON.stringify(data)
            .toLowerCase()
            .indexOf(this.searchText.toLowerCase()) !== -1
      );
    },
    items: {
      get: function () {
        return orderBy(
          this.reportListVal.slice(this.skip, this.take + this.skip),
          this.sort
        );
      },
    },
  },
  mounted(){
   this.getDataOnload();
  }

  }
  </script>
  <style lang="scss" scoped>
  .search_mobile{width: 15% !important; border-radius: 5px;}
 @media only screen and (max-width: 768px) {
  .search_mobile{width: 40% !important;}
  .mobile_hide_show{display: none;} 
  .driver_header_mobile{flex-direction: row !important; padding: 10px 10px 10px 10px;}
  .page-header .title-text {font-size: 12px;}
 }
 
 </style>
  